<div *ngIf="siteLayer$ | async as layers; else noLayers">
    <app-map [siteLayers]="layers"></app-map>
</div>
<ng-template #noLayers>
    <app-splash-screen></app-splash-screen>
</ng-template>

<router-outlet></router-outlet>